import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId"];
  static values = {
    selectedId: String,
  };

  connect() {
    StimulusReflex.register(this);
    console.log("OrganizationFormSearchController connected");
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Trigger the reflex
    this.stimulate("OrganizationFormSearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const organizationId = event.currentTarget.dataset.organizationId;
    const organizationName = event.currentTarget.dataset.organizationName;

    this.selectedIdTarget.value = organizationId;
    this.inputTarget.value = organizationName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
    this.selectedIdTarget.dispatchEvent(new Event("change"));
  }

  // Called by the reflex after search
  receiveResults(html) {
    this.resultsTarget.innerHTML = html;
    this.resultsTarget.classList.remove("hidden");
  }
}
